import script from "./SellerProfile.vue?vue&type=script&setup=true&lang=js"
export * from "./SellerProfile.vue?vue&type=script&setup=true&lang=js"

import "./SellerProfile.vue?vue&type=style&index=0&id=d16fb908&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d16fb908"]])

export default __exports__